<template>
    <div>
        <div v-if="labels[1725]" class="pull-left topborder">
            <a :href="'/'+getPageUrl(201)" target="_blank">
                <i class="csi-iconfont csi-info-circled normal"></i>{{labels[1725]}}
            </a>
            <a @click.prevent :id="randomID" class="shipinfo" href data-toggle="popover" tabindex="0" data-container="body" data-trigger="focus" data-placement="right" :data-title="labels[2162]" :data-content="labels[1183]" data-html="true">
                <img src="https://campbellsci-res.cloudinary.com/image/upload/w_15,c_limit/11876.png" class="marginleft10" />
                {{labels[2162]}}
            </a>
        </div>
        <div v-if="orderMeta.canSeePrices && orderMeta.orgs.length" class="pull-right topborder">
            <div v-if="orderMeta.orgs.length > 1">
                <div class="dropdown" id="switch-orgs">
                    <em>
                        {{labels[1172]}}<!-- label: Pricing:  -->
                        <a class="dropdown-toggle" data-toggle="dropdown" data-target="#switch-orgs" :title="orderMeta.primaryOrg.name">
                            {{orderMeta.primaryOrg.name}} <i class="caret"></i>
                        </a>
                    </em>
                    <ul class="dropdown-menu">
                        <li v-for="org in orderMeta.orgs" :key="org.iid">
                            <a href @click.prevent="checkSwitchOrg(org.iid)" v-show="org.iid != orderMeta.primaryOrg.iid && (org.iid != -1 || orderMeta.primaryOrg.iid != 3257)">
                                {{org.name}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-else>{{orderMeta.orgs[0].name}}</div>
        </div>
    </div>
</template>

<script>
import useCMS from '../../shared/composables/useCMS';
import useProductInfo from '../composables/useProductInfo';
import axios from 'axios';
import { computed } from '@vue/composition-api';

export default {
    name: 'orderBoxOptions',
    props: {
        product: Object
    },
    setup: function () {
        const { labels, getPageUrl } = useCMS();
        const { orderMeta } = useProductInfo();
        const randomID = computed(() => {
            var rand = (Math.floor(Math.random() * 20) + 1) * (Math.floor(Math.random() * 20) + 1);
            return 'shipInfo' + rand;
        });

        const checkSwitchOrg = (id) => {
            document.body.style.cursor = 'wait';
            var params = new URLSearchParams({
                section: 'subscriptions'
            });
            axios.post('/actions/cart.cfc?method=checkForCartSection', params).then(function (response) {
                if (response.data == 200 && response.idx > 0) {
                    if (confirm(`If you change organizations, all subscription renewals will be removed from the cart. Would you like to continue?`) == true) {
                        selectOrg(id);
                    } else {
                        document.body.style.cursor = 'default';
                    }
                } else {
                    selectOrg(id);
                }
            });
        }

        //Change the pricing
        const selectOrg = (id) => {
            var params = new URLSearchParams({
                custid: id
            });
            axios.post('/actions/cart.cfc?method=changeOrg', params).then(function() {
                document.body.style.cursor = 'default';
                window.location.reload();
            });
        }

        return {
            labels,
            getPageUrl,
            orderMeta,
            randomID,
            checkSwitchOrg
        }
    }
}
</script>
